<template>
  <div class="container">
    <h5>{{ t('servingCountTitle') }}</h5>
    <p>{{ t('servingCountDescription') }}</p>
    <EquationBlock :equations="equations" />
    <hr />
    <div class="row">
      <div class="col-sm">
        <!-- Inputs -->
        <GenericInput
          :input-label="t('productAmount')"
          v-model.number="productWeight"
          :conversion-factors="ConversionFactors.basicWeight"
        />
        <FixedUnitInput
          :input-label="t('productPotency')"
          v-model.number="productPotency"
          :unit="t('percentTHC')"
        />
        <FixedUnitInput
          :input-label="t('mgTHCPerServing')"
          v-model.number="mgPerServing"
          :unit="t('milligrams')"
        />
        <Checkbox
          :label="t('decarbCorrectionLabel')"
          v-model="decarbCorrection"
        />
      </div>
      <div class="col-sm">
        <!-- Output -->
        <FixedUnitOutput
          :output-label="t('servingsOutput')"
          :number="servings"
          :unit="t('servings')"
        />
      </div>
    </div>
  </div>
</template>

  
  <script>
  import { ref, computed, reactive } from 'vue';
  import { useI18n } from 'vue-i18n';
  import GenericInput from '../inputs/GenericInput.vue';
  import FixedUnitInput from '../inputs/FixedUnitInput.vue';
  import FixedUnitOutput from '../inputs/FixedUnitOutput.vue';
  import Checkbox from '../inputs/Checkbox.vue';
  import ConversionFactors from '../../utils/conversion_factors';
  import { defaultRound } from '../../utils/math';
  import EquationBlock from '../inputs/EquationBlock.vue';
  
  export default {
    components: {
      GenericInput,
      FixedUnitInput,
      FixedUnitOutput,
      Checkbox,
      EquationBlock
      // Import EquationBlock if it's a separate component
    },
    setup() {
      const productWeight = ref(10);
      const productPotency = ref(25);
      const mgPerServing = ref(100);
      const decarbCorrection = ref(true);

      const { t, tm } = useI18n();

      // Create a reactive object with a function
      const translations = reactive({
        t: (key) => t(key)
      })

      const equations = computed(() => {
          return tm('edibleServingEquations');
      });
  
      const decarbLoss = computed(() => 
        decarbCorrection.value ? 314.45 / 358.4733 : 1
      );
  
      const servings = computed(() => 
        defaultRound(
          productWeight.value *
          (productPotency.value / 100) *
          1000 *
          decarbLoss.value /
          mgPerServing.value
        )
      );
  
      return {
        productWeight,
        productPotency,
        mgPerServing,
        decarbCorrection,
        servings,
        ConversionFactors,
        equations,
        t: translations.t
      };
    },
  };
  </script>
  